<section class="breadcrumb-banner">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="breadcrumb-text">
          <h1>
            2<sup>nd</sup> Maharashtra State Sub-Junior Selection
            Badminton <br> Tournament 2026
          </h1>
        </div>
      </div>
    </div>
  </div>
  <div class="breadcrumb-bottom-img">
    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
  </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
  <div class="container">
    <div class="sec-title text-center mb-5">
      <h2><span>YONEX-SUNRISE G.H. Raisoni Memorial 2<sup>nd</sup> Maharashtra State Sub-Junior (U-9, U-11 & U-13)
          Selection
          Badminton Tournament 2026</span></h2>
    </div>
    <div class="row justify-content-between">
      <div class="col-md-7">
        <p>
          <span class="text-dark">Dates:</span> 5th - 9th August 2026
        </p>
        <p>
          <span class="text-dark">Location:</span> Jilha Stadium, Morshi Road, Amravati – 444602, Maharashtra
        </p>
        <p>
          <span class="text-dark">Level:</span> State / Selection Level
        </p>
        <p>
          <span class="text-dark">Organizer:</span> G. H. Raisoni Foundation
        </p>

        <h5 class="primary-purple">Overview</h5>
        <p>The YONEX-SUNRISE G.H. Raisoni Memorial 2nd Maharashtra State Sub-Junior (U-9, U-11 & U-13) Selection
          Badminton Tournament 2026 was successfully conducted from 5th to 9th August 2026 at Jilha Stadium, Morshi
          Road, Amravati – 444602. The tournament was held at the State/Selection level, providing a competitive
          platform for young badminton players from across Maharashtra.</p>
      </div>
      <div class="col-md-4">
        <div class="image-effect-3">
          <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-1.webp"
            alt="GHRSCF">
        </div>
      </div>

      <h5 class="primary-purple">Tournament Highlights</h5>
      <p>The championship received an overwhelming response, with 693 entries and 472 players participating across
        11 events in the U-9, U-11 and U-13 age categories. A total of 669 matches were played during the five-day
        championship.</p>
      <p>The tournament featured:</p>
      <ul class="list-style list-style1 list-count mb-3">
        <li>Boys' Singles – U-9, U-11 &amp; U-13</li>
        <li>Girls' Singles – U-9, U-11 &amp; U-13</li>
        <li>Boys' Doubles – U-11 &amp; U-13</li>
        <li>Girls' Doubles – U-11 &amp; U-13</li>
        <li>Mixed Doubles – U-13</li>
      </ul>

      <h5 class="primary-purple">Inauguration Ceremony</h5>
      <p>The tournament was inaugurated by Shri. Avinash Deshmukh, Vice President, YDBA, who graced the occasion as
        the Chief Guest.</p>
      <p>The inauguration ceremony was also attended by:</p>
      <ul class="list-style list-style1 list-count mb-3">
        <li>Shri. Pradeep Gabada – Hon. Secretary, YDBA</li>
        <li>Dr. Virendra Talreja – Hon. Jt. Secretary, YDBA</li>
        <li>Shri. Deviprasad Agrawal – Executive Member, YDBA</li>
        <li>Shri. Sunil Deshmukh – Tournament Secretary</li>
      </ul>
      <p>Their presence encouraged the young players and added significance to the opening ceremony.</p>

      <h5 class="primary-purple">Tournament Officials</h5>
      <p>The tournament was officiated by Referee Aniruddha Joshi, with Parijat Natu serving as Deputy Referee.</p>

      <h5 class="primary-purple">Prize Distribution Ceremony</h5>
      <p>The Prize Distribution Ceremony was graced by Shri. Raj Dahiwade Sir, Raisoni Group, Yavatmal Branch, who
        presented the prizes and felicitated the deserving winners and participants.</p>
      <p>The ceremony was also attended by:</p>
      <ul class="list-style list-style1 list-count mb-3">
        <li>Shri. Avinash Deshmukh – Vice President, YDBA</li>
        <li>Shri. Pradeep Gabada – Hon. Secretary, YDBA</li>
        <li>Shri. Dinesh Dattani – Treasurer, YDBA</li>
      </ul>
      <p>The presence of the dignitaries motivated the young athletes and added a memorable conclusion to the
        championship.</p>

      <h5 class="primary-purple">Winners & Achievements</h5>
      <p>The tournament showcased some of Maharashtra's promising young badminton talent.</p>
      <ul class="list-style list-style1 list-count mb-3">
        <li><span class="text-dark">Boys' Singles U-9:</span> Vivaan Burnwal</li>
        <li><span class="text-dark">Girls' Singles U-9:</span> Nirja Pawar</li>
        <li><span class="text-dark">Boys' Singles U-11:</span> Shaunak Kelkar</li>
        <li><span class="text-dark">Girls' Singles U-11:</span> Keyara Sakhare</li>
        <li><span class="text-dark">Boys' Singles U-13:</span> Rudra Manohar</li>
        <li><span class="text-dark">Girls' Singles U-13:</span> Divisha Singh</li>
        <li><span class="text-dark">Boys' Doubles U-11:</span> Gautam Sathe &amp; Shaunak Kelkar</li>
        <li><span class="text-dark">Girls' Doubles U-11:</span> Keyara Sakhare &amp; Khrisha Goyal</li>
        <li><span class="text-dark">Boys' Doubles U-13:</span> Aadiraj Shetty &amp; Ronit Jadhav</li>
        <li><span class="text-dark">Girls' Doubles U-13:</span> Anisha Pinge &amp; Rutva Pande</li>
        <li><span class="text-dark">Mixed Doubles U-13:</span> Parasmay Rane &amp; Rutva Pande</li>
      </ul>

      <h5 class="primary-purple">Conclusion</h5>
      <p>The five-day championship concluded successfully with intense competition, impressive performances and
        valuable exposure for emerging badminton players from across Maharashtra. The event provided young athletes
        with an excellent opportunity to compete at the state selection level and showcase their talent.</p>
      <p>The successful conduct of the championship reflects the continued commitment towards promoting grassroots
        badminton, nurturing young sporting talent and providing competitive platforms for the next generation of
        athletes.</p>
      <p>The G.H. Raisoni Memorial Tournament continues its endeavour to support sports and inspire young athletes to
        pursue excellence.</p>

      <div class="sec-title mt-5 text-center">
        <h2><span>Photo Gallery</span></h2>
        <hr>
      </div>
      <div class="lightBox--gallery">
        <ul class="list-unstyled lightgallery row row-cols-1 justify-content-center row-cols-md-3">
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-1.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-1.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-1.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-2.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-2.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-2.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-3.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-3.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-3.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-4.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-4.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-4.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-5.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-5.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-5.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
